import { render, staticRenderFns } from "./QueueManage.vue?vue&type=template&id=0b7bcb57"
import script from "./QueueManage.vue?vue&type=script&lang=js"
export * from "./QueueManage.vue?vue&type=script&lang=js"
import style0 from "./QueueManage.vue?vue&type=style&index=0&id=0b7bcb57&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports